import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MessageService } from 'src/app/services/message.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-update-self-password-dialog',
  templateUrl: './update-self-password-dialog.component.html',
  styleUrls: ['./update-self-password-dialog.component.scss'],
})
export class UpdateSelfPasswordDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<UpdateSelfPasswordDialogComponent>,
    private api: UserApiService,
    private message: MessageService,
    private user: UserService
  ) {}

  password1 = '';
  password2 = '';

  loading = false;
  async onOk() {
    this.password1 = this.password1.trim();
    this.password2 = this.password2.trim();
    if (!this.password1 || !this.password2) {
      return;
    }
    if (this.password1 != this.password2) {
      this.message.warn('两次密码输入不一致，请确认');
      return;
    } else if (this.password1.length < 6) {
      this.message.warn('密码长度至少六位');
      return;
    }
    this.updateSelfNickname(this.password1);
  }

  async updateSelfNickname(password: string) {
    try {
      this.loading = true;
      const r = await this.api.updateSelfPassword(password);
      if (r.status !== 0) {
        this.message.warn('未知错误');
      } else {
        this.message.open('密码修改成功');
        this.dialogRef.close();
      }
    } catch (error) {
      this.message.error('网络错误');
    } finally {
      this.loading = false;
    }
  }
}
